import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payment-link-user',
  templateUrl: './payment-link-user.component.html',
  styleUrls: ['./payment-link-user.component.css']
})
export class PaymentLinkUserComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
